"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Arrow = function Arrow(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#000' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="8" height="4"' : size;
  var title = 'Arrow Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" ").concat(iconSize, " viewBox=\"0 0 8 4\" fill=\"none\" xmlns='http://www.w3.org/2000/svg'>\n      <title>").concat(title, "</title>\n      <path d=\"M0 0L4 4L8 0H0Z\" fill=\"").concat(color, "\" />\n    </svg>\n  ");
};

var _default = Arrow;
exports["default"] = _default;